import { render, staticRenderFns } from "./SingleRank.vue?vue&type=template&id=6b124e84&scoped=true"
import script from "./SingleRank.vue?vue&type=script&lang=ts"
export * from "./SingleRank.vue?vue&type=script&lang=ts"
import style0 from "./SingleRank.vue?vue&type=style&index=0&id=6b124e84&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b124e84",
  null
  
)

export default component.exports